import { Fab, Stack } from "@mui/material";
import React from "react";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import MapIcon from "@mui/icons-material/Map";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useSelector } from "react-redux";

const FloatingActions = ({ carData }) => {
  const lang = useSelector((state) => state.global.language);
  const isMob = useSelector((state) => state.global.isMobile);
  return (
    <Stack
      direction={"column"}
      spacing={1}
      useFlexGap
      sx={{
        position: "fixed",
        right: lang === "en" ? (!!isMob ? "1rem" : "2rem") : "85%",
        bottom: "2rem",
        zIndex: 99,
      }}
    >
      <Fab
        // variant="extended"
        color="primary"
        size="small"
        onClick={() =>
          (window.location = `tel:${
            carData !== undefined ? carData?.usedCarEn?.phone : 600520003
          }`)
        }
      >
        <PhoneEnabledIcon />
        {/* <Typography sx={{ marginLeft: ".25rem" }}>Call now</Typography> */}
      </Fab>
      <Fab
        // variant="extended"
        color="primary"
        size="small"
        // sx={{ position: "fixed", right: "1rem", bottom: "1rem" }}
        onClick={() =>
          window.open(
            `https://api.whatsapp.com/send/?phone=971${carData?.usedCarEn?.phone.substring(1)}&type=phone_number&app_absent=0`,
            "_blank"
          )
        }
      >
        <WhatsAppIcon />
        {/* <Typography sx={{ marginLeft: ".25rem" }}>
        {" "}
        Chat with us
      </Typography> */}
      </Fab>
      <Fab
        // variant="extended"
        color="primary"
        size="small"
        // sx={{ position: "fixed", right: "1rem", bottom: "1rem" }}
        onClick={() =>
          window.open(`${carData?.usedCarEn?.locationUrl}`, "_blank")
        }
      >
        <MapIcon />
        {/* <Typography sx={{ marginLeft: ".25rem" }}>
        {" "}
        Chat with us
      </Typography> */}
      </Fab>
    </Stack>
  );
};

export default FloatingActions;
